import {
    Box,
    Button,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    Switch,
    TextField,
    Stack,
} from "@mui/material";
import axios from "axios";
import { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const MasterDEMO = () => {
    const [country, setCountry] = useState("us");
    const [country2, setCountry2] = useState("us");
    const [typeOfCall, setTypeOfCall] = useState("prod"); // prod vs dev
    const [selectedAgency, setSelectedAgency] = useState("jaspervocal");

    const [testV2DropdownOption, setTestV2DropdownOption] = useState("");
    const [testV2FirstName, setTestV2FirstName] = useState("");
    const [testV2State, setTestV2State] = useState("");
    const [testV2FacebookPageName, setTestV2FacebookPageName] = useState("");
    const [testV2PhoneNumber, setTestV2PhoneNumber] = useState("");
    const [testV2LiveTransferPhoneNumber, setTestV2LiveTransferPhoneNumber] = useState("");
    const [testV2HumanAgentFirstName, setTestV2HumanAgentFirstName] = useState("");
    const [usesProxyNumber, setUsesProxyNumber] = useState(false);

    useEffect(() => {
        setTestV2DropdownOption("");
        setTestV2HumanAgentFirstName("");
        // Reset typeOfCall to prod if switching away from jaspervocal while htfe options are selected
        if ((typeOfCall === "htfe_conv_flow" || typeOfCall === "htfe_single_prompt") && selectedAgency !== "jaspervocal") {
            setTypeOfCall("prod");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAgency]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const friendlyNames = {
            med_supp_cc_lt: "Medicare Voice Leads",
            med_supp_fb_lt: "Medicare Supplement Facebook",
            med_supp_t65_fb_lt: "Medicare T65 Facebook",
            mapd_fb_lt: "MAPD Facebook",
            final_expense_fb_lt: "Final Expense Facebook",
            final_expense_cc_lt: "Final Expense Voice Leads",
            affordable_care_act_cc_lt: "ACA Voice Leads",
            mortgage_protection_cc_app: "Mortgage Protection Voice Leads - no LT",
            mortgage_protection_cc_lt: "Mortgage Protection Voice Leads",
            iul_fb_lt: "IUL Facebook Leads",
            iul_variant_1_jack: "IUL Appointments Variant 1 (Jack)",
            iul_variant_2_jack: "IUL Appointments Variant 2 (Jack)",
            high_ticket_final_expense_cc_lt: "High Ticket Final Expense",
            high_ticket_mortgage_protection_cc_lt: "High Ticket Mortgage Protection",
            high_ticket_final_expense_fb_lt: "High Ticket Final Expense Facebook",
            high_ticket_pi_final_expense_cc_lt: "The People's Insurance Final Expense",
            ab360_smb_calling_out_of_the_blue: "AB360 SMB Calling Out of the Blue",
            ab360_smb_can_you_help_me: "AB360 SMB Can You Help Me",
            ab360_smb_not_sure_open_to: "AB360 SMB Not Sure Open To",
            ab360_smb_quick_question: "AB360 SMB Quick Question",
            ab360_smb_safe_distance: "AB360 SMB Safe Distance",
            ab360_smb_uncertain_permission: "AB360 SMB Uncertain Permission",
            ab360_new_outreach_v3: "AB360 New Outreach V3",
            ab360_lead_reactivation_v1: "AB360 Lead Reactivation V1",
            ab360_alternate_outreach: "AB360 Alternate Outreach"
        };

        const agencyConfigs = {
            jaspervocal: {
                prod_agent_id: "agent_dfe0b902547485242e619d73fd",
                dev_agent_id: "agent_0e180abd5ecee987912940baa8",
                htfe_conv_flow_agent_id: "agent_67c218e214d729703459f3d5a7",
                htfe_single_prompt_agent_id: "agent_544df57c496bc115e97c9368f4",
            },
            agentautopilot: {
                prod_agent_id: "agent_01b2663eaef5ae0af96f34cf22",
                dev_agent_id: "agent_743f58f04ff54775810999cadc",
            },
            ab360: {
                prod_agent_id: "agent_30ce2134ef786f89151af8b879",
                dev_agent_id: "agent_290e4ddd9c79c0205602020c4a",
            }
        };


        let agent_id;
        if (typeOfCall === "prod") {
            agent_id = agencyConfigs[selectedAgency].prod_agent_id;
        } else if (typeOfCall === "htfe_conv_flow") {
            agent_id = agencyConfigs[selectedAgency].htfe_conv_flow_agent_id;
        } else if (typeOfCall === "htfe_single_prompt") {
            agent_id = agencyConfigs[selectedAgency].htfe_single_prompt_agent_id;
        } else {
            agent_id = agencyConfigs[selectedAgency].dev_agent_id;
        }

        const human_agent_first_name = testV2DropdownOption === "high_ticket_final_expense_fb_lt" 
            ? testV2HumanAgentFirstName 
            : "Marco";


        const fromNumber = "12392081459";
        const baseUrl =
            "https://initiate-retell-call-7blmr5azyq-uc.a.run.app";
        let human_agent_id = "0ho90QkFDmsLuKGZ4iAv";
        let lead_id = "FSHpnvJoxO7iFKP63BxF";
        let lead_first_name = testV2FirstName;
        let lead_state = testV2State;
        let human_agent_company_name;
        if (selectedAgency === 'ab360') {
            human_agent_company_name = "American Trustee";
        } else {
            human_agent_company_name = testV2FacebookPageName === "" ? "Senior Services" : testV2FacebookPageName;
        }
        let human_agent_number = `+${testV2LiveTransferPhoneNumber}`;
        let lead_type = (typeOfCall === "htfe_conv_flow" || typeOfCall === "htfe_single_prompt") ? "high_ticket_final_expense_cc_lt" : testV2DropdownOption;
        const cal_api_key = ["iul_variant_1_jack", "iul_variant_2_jack"].includes(lead_type)
            ? "cal_live_c276f90635016462bcb781ab016b6bc9"
            : undefined;
        let lead_type_friendly_name = friendlyNames[lead_type] || lead_type;
        let lead_tz = "America/Chicago";
        let human_agent_tz = "America/New_York";
        let to_number = testV2PhoneNumber;
        let url = `${baseUrl}?lead_id=${lead_id}&lead_first_name=${lead_first_name}&from_number=${fromNumber}&agent_id=${agent_id}&human_agent_id=${human_agent_id}&human_agent_company_name=${human_agent_company_name}&to_number=+${to_number}&lead_state=${lead_state}&human_agent_number=${human_agent_number}&human_agent_first_name=${human_agent_first_name}&lead_type=${lead_type}&human_agent_tz=${human_agent_tz}&lead_tz=${lead_tz}&lead_type_friendly_name=${lead_type_friendly_name}${cal_api_key ? `&cal_api_key=${cal_api_key}` : ""}&uses_proxy_number=${usesProxyNumber.toString()}`;

        console.log(`Starting call with URL ${url}`);

        await axios
            .request(
                url,
                {
                    method: "GET",
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                    },
                }
            )
            .then((res) => window.alert("Call initiated successfully!"));
    };


    // Function to get queue options based on selected agency
    const getQueueOptions = () => {
        const baseQueues = [
            { value: "med_supp_cc_lt", label: "Medicare Voice Leads" },
            { value: "med_supp_fb_lt", label: "Medicare Supplement Facebook" },
            { value: "med_supp_t65_fb_lt", label: "Medicare T65 Facebook" },
            { value: "mapd_fb_lt", label: "MAPD Facebook" },
            { value: "iul_fb_lt", label: "IUL Facebook Leads" },
            { value: "final_expense_fb_lt", label: "Final Expense Facebook" },
            { value: "final_expense_cc_lt", label: "Final Expense Voice Leads" },
            { value: "affordable_care_act_cc_lt", label: "ACA Voice Leads" },
            { value: "mortgage_protection_cc_app", label: "Mortgage Protection Voice Leads - no LT" },
            { value: "mortgage_protection_cc_lt", label: "Mortgage Protection Voice Leads" }
        ];

        if (selectedAgency === 'jaspervocal') {
            const jasperQueues = [
                ...baseQueues,
                { value: "home_cc_lt", label: "Home Voice Leads"},
                { value: "auto_cc_lt", label: "Auto Voice Leads"},
                { value: "high_ticket_final_expense_cc_lt", label: "High Ticket Final Expense"},
                { value: "high_ticket_mortgage_protection_cc_lt", label: "High Ticket Mortgage Protection"},
                { value: "high_ticket_final_expense_fb_lt", label: "High Ticket Final Expense Facebook"},
                { value: "high_ticket_pi_final_expense_cc_lt", label: "The People's Insurance Final Expense"}
            ];

            if (typeOfCall === "dev") {
                jasperQueues.push(
                    { value: "iul_variant_1_jack", label: "IUL Appointments Variant 1 (Jack)" },
                    { value: "iul_variant_2_jack", label: "IUL Appointments Variant 2 (Jack)" }
                );
            }

            return jasperQueues;
        }

        if (selectedAgency === 'ab360') {
            return [
                { value: "ab360_smb_calling_out_of_the_blue", label: "AB360 SMB Calling Out of the Blue" },
                { value: "ab360_smb_can_you_help_me", label: "AB360 SMB Can You Help Me" },
                { value: "ab360_smb_not_sure_open_to", label: "AB360 SMB Not Sure Open To" },
                { value: "ab360_smb_quick_question", label: "AB360 SMB Quick Question" },
                { value: "ab360_smb_safe_distance", label: "AB360 SMB Safe Distance" },
                { value: "ab360_smb_uncertain_permission", label: "AB360 SMB Uncertain Permission" },
                { value: "ab360_new_outreach_v3", label: "AB360 New Outreach V3" },
                { value: "ab360_lead_reactivation_v1", label: "AB360 Lead Reactivation V1" },
                { value: "ab360_alternate_outreach", label: "AB360 Alternate Outreach" },
            ];
        }

        return baseQueues;
    };

    return (
        <div className="full-page-background">
            <Grid item xs={12} md={7}>
                <Container className="App" maxWidth="sm">
                    <img src={logo} className="App-logo" alt="logo" />
                    <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                        <h1 style={{
                            color: '#FFFFFF',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            margin: '1rem',
                        }}>
                            Master DEMO Page
                        </h1>
                        <div style={{
                            height: '4px',
                            width: '100px',
                            background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
                            margin: '0 auto',
                            borderRadius: '2px'
                        }}></div>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '0 auto 1.5rem auto',
                        background: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: '30px',
                        padding: '6px',
                        border: '1px solid rgba(100, 181, 246, 0.2)',
                        maxWidth: 'fit-content',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                    }}>
                        {[
                            { key: 'jaspervocal', label: 'Agent Autodialer' },
                            { key: 'agentautopilot', label: 'Agent Autopilot' },
                            // { key: 'ab360', label: 'Agent Boost 360' } // Disabled for now
                        ].map(({ key, label }) => (
                            <span
                                key={key}
                                onClick={() => setSelectedAgency(key)}
                                style={{
                                    cursor: 'pointer',
                                    color: selectedAgency === key ? '#ffffff' : '#b0bec5',
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    padding: '8px 18px',
                                    borderRadius: '24px',
                                    transition: 'all 0.3s ease',
                                    background: selectedAgency === key
                                        ? 'linear-gradient(135deg, rgba(100, 181, 246, 0.4), rgba(66, 165, 245, 0.6))'
                                        : 'transparent'
                                }}
                            >
                                {label}
                            </span>
                        ))}
                    </div>

                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>

                            <>
                                <Select
                                    value={typeOfCall}
                                    onChange={(e) => {
                                        setTypeOfCall(e.target.value);
                                    }}
                                    required
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        textAlign: "left",
                                    }}
                                >
                                    <MenuItem value="prod">Production Release</MenuItem>
                                    <MenuItem value="dev">Development and Testing</MenuItem>
                                    {selectedAgency === 'jaspervocal' && (
                                        <MenuItem value="htfe_conv_flow">HTFE Conversation Flow</MenuItem>
                                    )}
                                    {selectedAgency === 'jaspervocal' && (
                                        <MenuItem value="htfe_single_prompt">HTFE Single Prompt</MenuItem>
                                    )}
                                </Select>
                                {typeOfCall !== "htfe_conv_flow" && typeOfCall !== "htfe_single_prompt" && (
                                    <Select
                                        value={testV2DropdownOption}
                                        onChange={(e) => {
                                            setTestV2DropdownOption(e.target.value);
                                        }}
                                        displayEmpty
                                        required
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            <span style={{ color: '#999' }}>Select a queue</span>
                                        </MenuItem>
                                        {getQueueOptions().map((queue) => (
                                            <MenuItem key={queue.value} value={queue.value}>
                                                {queue.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                                {(testV2DropdownOption !== "" || typeOfCall === "htfe_conv_flow" || typeOfCall === "htfe_single_prompt") && (

                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    {typeOfCall === "htfe_conv_flow" || typeOfCall === "htfe_single_prompt" ||
                                        testV2DropdownOption === "med_supp_cc_lt" ||
                                        testV2DropdownOption === "final_expense_cc_lt" ||
                                        testV2DropdownOption === "affordable_care_act_cc_lt" ||
                                        testV2DropdownOption === "mortgage_protection_cc_app" ||
                                        testV2DropdownOption === "mortgage_protection_cc_lt" ||
                                        testV2DropdownOption === "iul_fb_lt" ||
                                        testV2DropdownOption === "home_cc_lt" ||
                                        testV2DropdownOption === "auto_cc_lt" ||
                                        testV2DropdownOption === "high_ticket_final_expense_cc_lt" ||
                                        testV2DropdownOption === "high_ticket_mortgage_protection_cc_lt" ||
                                        testV2DropdownOption === "high_ticket_final_expense_fb_lt" ||
                                        testV2DropdownOption === "high_ticket_pi_final_expense_cc_lt" ||
                                        testV2DropdownOption.startsWith("ab360_") ? (
                                            <>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label="Lead First Name"
                                                type="text"
                                                fullWidth
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                }}
                                                value={testV2FirstName}
                                                onChange={(e) => setTestV2FirstName(e.target.value)}
                                                />
                                            <TextField
                                                margin="dense"
                                                label="State"
                                                type="text"
                                                fullWidth
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                }}
                                                value={testV2State}
                                                onChange={(e) => setTestV2State(e.target.value)}
                                                />
                                            {testV2DropdownOption === "high_ticket_final_expense_fb_lt" && (
                                                <TextField
                                                    margin="dense"
                                                    label="Human Agent First Name"
                                                    type="text"
                                                    fullWidth
                                                    sx={{
                                                        color: "white",
                                                        backgroundColor: "white",
                                                        borderRadius: "4px",
                                                    }}
                                                    value={testV2HumanAgentFirstName}
                                                    onChange={(e) => setTestV2HumanAgentFirstName(e.target.value)}
                                                    />
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label="Lead First Name"
                                                type="text"
                                                fullWidth
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                }}
                                                value={testV2FirstName}
                                                onChange={(e) => setTestV2FirstName(e.target.value)}
                                                />
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label="Company Name"
                                                type="text"
                                                fullWidth
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                }}
                                                value={testV2FacebookPageName}
                                                onChange={(e) => setTestV2FacebookPageName(e.target.value)}
                                                />
                                            <TextField
                                                margin="dense"
                                                label="State"
                                                type="text"
                                                fullWidth
                                                sx={{
                                                    color: "white",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                }}
                                                value={testV2State}
                                                onChange={(e) => setTestV2State(e.target.value)}
                                                />
                                        </>
                                    )}
                                </Stack>
                        )}
                            </>
                            <h3 style={{
                                color: '#FFFFFF',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                margin: '16px 0 0 0',
                                textAlign: 'left'
                            }}>
                                Your Number
                            </h3>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                                    <Select
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            height: "56px",
                                        }}
                                        required
                                    >
                                        <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                                        <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                                        <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                                    <PhoneInput
                                        country={country}
                                        value={testV2PhoneNumber}
                                        disableDropdown={true}
                                        disableCountryGuess={true}
                                        onChange={setTestV2PhoneNumber}
                                        enableLongNumbers={true}
                                        placeholder="Enter your phone number"
                                        inputStyle={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            height: "56px",
                                            borderRadius: "4px",
                                            border: "1px solid #ced4da",
                                        }}
                                        required
                                    />
                                </Box>
                            </Stack>
                            <h3 style={{
                                color: '#FFFFFF',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                margin: '16px 0 0 0',
                                textAlign: 'left'
                            }}>
                                Live Transfer Number
                            </h3>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                                    <Select
                                        value={country2}
                                        onChange={(e) => setCountry2(e.target.value)}
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            height: "56px",
                                        }}
                                        required
                                    >
                                        <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                                        <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                                        <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                                    <PhoneInput
                                        country={country2}
                                        value={testV2LiveTransferPhoneNumber}
                                        disableDropdown={true}
                                        disableCountryGuess={true}
                                        onChange={setTestV2LiveTransferPhoneNumber}
                                        enableLongNumbers={true}
                                        placeholder="Enter live transfer phone number"
                                        inputStyle={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            height: "56px",
                                            borderRadius: "4px",
                                            border: "1px solid #ced4da",
                                        }}
                                        required
                                    />
                                </Box>
                            </Stack>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={usesProxyNumber}
                                        onChange={(e) => setUsesProxyNumber(e.target.checked)}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#1976d2',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#1976d2',
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <span style={{ color: '#FFFFFF', fontSize: '1rem', fontWeight: '500' }}>
                                        Uses Proxy Number
                                    </span>
                                }
                                sx={{
                                    marginTop: '16px',
                                    marginBottom: '8px',
                                }}
                            />
                            <Button
                                className="callBtn"
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{
                                    background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                                    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                                    color: 'white',
                                    height: '56px',
                                    padding: '0 30px',
                                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                                        background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                                    },
                                }}
                            >
                                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                                    Click here to receive the DEMO call
                                </h2>
                                <div style={{ width: "20px" }} />
                                <Call className="callIcon" />
                            </Button>
                            <div style={{
                                // Bubble Container Styles
                                backgroundColor: '#eaf2fa',
                                padding: '16px',
                                borderRadius: '8px',
                                border: '1px solid #d0e0f0',

                                // Flexbox for alignment
                                display: 'flex',
                                alignItems: 'center', // Vertically centers the icon and text
                                gap: '12px'           // Adds space between the icon and text
                            }}>
                                {/* Icon */}
                                <span style={{ fontSize: '24px' }}>ℹ️</span>

                                {/* Text Content */}
                                <p style={{
                                    margin: 0, // Resets default paragraph margin
                                    textAlign: 'left',
                                    color: '#333',
                                    lineHeight: '1.5',
                                    fontSize: '14px'
                                }}>
                                    After clicking to receive the DEMO call, you will receive a call from the following number:
                                    <b style={{ color: '#005a9c' }}> +1 (239) 208-1459</b>
                                </p>
                            </div>
                        </Stack>
                    </form>
                </Container>
            </Grid>
        </div>
    );
};
